import { render, staticRenderFns } from "./PromoCodeOffers.vue?vue&type=template&id=5ea5b14c&scoped=true&"
import script from "./PromoCodeOffers.vue?vue&type=script&lang=js&"
export * from "./PromoCodeOffers.vue?vue&type=script&lang=js&"
import style0 from "./PromoCodeOffers.vue?vue&type=style&index=0&id=5ea5b14c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea5b14c",
  null
  
)

export default component.exports